import React from "react";
import animations from './animations';
import PropTypes from "prop-types";


const fills = [
    'fill-navy', 'fill-blue', 'fill-aqua', 'fill-teal',
    'fill-olive', 'fill-green', 'fill-lime', 'fill-yellow',
    'fill-orange', 'fill-red', 'fill-fuchsia', 'fill-purple',
    'fill-maroon', 'fill-gray', 'fill-silver', 'fill-black',
];


class AppLoadingScreen extends React.PureComponent {
    static propTypes = {
        blank: PropTypes.bool,
        text: PropTypes.string,
    }

    static defaultProps = {
        blank: false,
        text: '',
    }

    state = {
        animation: animations[Math.floor(Math.random() * animations.length)],
        className: fills[Math.floor(Math.random() * fills.length)],
    }

    render() {
        const {blank, text} = this.props;

        if (blank) {
            return null;
        }

        const Animation = this.state.animation;
        const className = this.state.className;

        return (
            <div id="app-loading-screen" className="d-flex flex-centered">
                <Animation className={className}/>
                {text && <div id="app-loading-screen-text">{text}</div>}
            </div>
        );
    }
}


export default AppLoadingScreen;